import PropTypes from "prop-types";
import React from "react";
import { MenuItem, DropdownButton } from "react-bootstrap";

import SettingActions from "../../actions/SettingActions";

import { orderings } from "../../constants/AppConstants";

import UserStore from "../../stores/UserStore";

export default class BudgetOrderingSetting extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = BudgetOrderingSetting.getStoreState();
		this._onChange = this._onChange.bind(this);
		this.handleOrderingChange = this.handleOrderingChange.bind(this);
	}

	static getStoreState()
	{
		return {
			budgetOrdering: UserStore.getUserProfileSetting("budgetOrdering")
		};
	}

	async handleOrderingChange(orderingValue)
	{
		const ordering = orderings.find(t => t.value === orderingValue);
		await SettingActions.updateUserProfile("BudgetOrdering", ordering.value);
	}

	_onChange()
	{
		this.setState(BudgetOrderingSetting.getStoreState());
	}

	componentDidMount()
	{
		UserStore.addChangeListener(this._onChange);
	}

	componentWillUnmount()
	{
		UserStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const selectedOrderingValue = this.state.budgetOrdering;
		const selectedOrdering = orderings.find(ordering => ordering.value === selectedOrderingValue);
		const title = (selectedOrdering ? selectedOrdering.displayName : selectedOrderingValue) || "amount:asc";
		let enabled = this.props.enabled;

		return (
			<DropdownButton
				onSelect={this.handleOrderingChange}
				title={title}
				id="budgetOrderingChange"
				disabled={!enabled}
			>
				{orderings.map(ordering => {
					return (
						<MenuItem
							key={ordering.value}
							eventKey={ordering.value}
							className={ordering.value === selectedOrderingValue ? "active" : ""}
						>
							{ordering.displayName}
						</MenuItem>
					);
				})}
			</DropdownButton>
		);
	}
}

BudgetOrderingSetting.propTypes = {
	enabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/settings/BudgetOrderingSetting.jsx